import * as React from "react";
import { Context } from "./_context";
export const BotMicIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.75 7.5a4.25 4.25 0 0 0 8.5 0V7h1.5v.5a5.75 5.75 0 0 1-5 5.7v2.3h-1.5v-2.3a5.75 5.75 0 0 1-5-5.7V7h1.5v.5ZM8 .75a2.75 2.75 0 0 1 2.75 2.75v4a2.75 2.75 0 1 1-5.5 0v-4A2.75 2.75 0 0 1 8 .75Zm0 1.5c-.69 0-1.25.56-1.25 1.25v4a1.25 1.25 0 0 0 2.5 0v-4c0-.69-.56-1.25-1.25-1.25Z", fill: "currentColor" }));
  return iconset[size];
};
BotMicIcon.iconId = "5TS8FO";
